import { Input } from '@chakra-ui/react';
import { ChangeEvent } from 'react';

import { useFilterState } from '../../hooks/useFilterState';
import { FilterPopoverContent } from '../FilterPopoverButton';

type Props = {
  onChange: (value: string) => void;
  onSubmit: () => void;
};

export const StringFilterPopoverContent = ({ onChange, onSubmit }: Props) => {
  const state = useFilterState({
    defaultValue: '',
    onSubmit,
  });

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const nextValue = event.target.value;
    onChange(nextValue);
    state.onChange(nextValue);
  };

  return (
    <FilterPopoverContent onClickApply={state.onSubmit} onClickCancel={state.onReset}>
      <Input value={state.value} onChange={handleChange} />
    </FilterPopoverContent>
  );
};
